export const API_CONTRACT_VERSION = 18;
export const LEGACY_API_CONTRACT_VERSION = 1;
export const API_CONTRACT_VERSION_HEADER = 'x-wire-version';
//# sourceMappingURL=index.js.map